<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()">
  <div class="wrapper--spacing-vertical flex__child--auto">
    <div [attr.data-test]="'kpi-chart-description_' + data.kpi">
      {{ 'performance.kpi-chart-description' | translate }}
      {{ 'performance.kpi.' + data.kpi | translate }}
    </div>

    <div class="wrapper--spacing-vertical flex__child--auto">
      <agr-chart
        *ngIf="!!chartSeries"
        [options]="chartOptions"
        [dataSource]="chartSeries"
      ></agr-chart>
    </div>
  </div>
</agr-dialog>
